export default __webpack_public_path__ + "static/media/log-out.9d770e13.svg";